import React, { Component } from 'react';
import './App.css';
import Image_fill from './Image_fill';
import img_elImage from './images/Image_fill_elImage_back_1322448678.png';
import btn_icon_685443925 from './images/btn_icon_685443925.png';
import btn_icon_505087 from './images/btn_icon_505087.png';
import img_elBig_image from './images/Image_fill_elImage_back_1322448678.png';
import btn_icon_255121260 from './images/btn_icon_255121260.png';
import btn_icon_back_chuterunot from './images/btn_icon_back_chuterunot.png';

// UI framework component imports
import Textarea from 'muicss/lib/react/textarea';
import Button from 'muicss/lib/react/button';
import Appbar from 'muicss/lib/react/appbar';

export default class ChuterUnOTScreen extends Component {

  // Properties used by this component:
  // appActions, deviceInfo, state, type, color

  constructor(props) {
    super(props);
    
    this.state = {
      text: (<div>Annuler et renvoyer au planning ?</div>),
      text_plainText: "Annuler et renvoyer au planning ?",
      site: (<div>&lt;no value from script&gt;</div>),
      site_plainText: "<no value from script>",
      flux: (<div>undefined - Hors quai</div>),
      flux_plainText: "undefined - Hors quai",
      type: (<div>undefined</div>),
      type_plainText: "undefined",
      exutoire: (<div> </div>),
      exutoire_plainText: " ",
      remark: (<div> </div>),
      remark_plainText: " ",
      commentaire: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_commentaire'] : '') || '',
      elErase_visible: false,
      elCapture_visible: true,
      elBig_image_visible: false,
      commentaire_fg: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_commentaire'] : '') || '',
    };
  }

  componentDidMount() {
    
    let mobileCheck = () => {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      check = window.matchMedia("(orientation: landscape)").matches && check;
      if (check && !this.state.elCommentaire_fg_visible) {
        this.setState({
          elCommentaire_fg_visible: true,
          elSave_input_visible: true,
        })
        document.querySelector(".elCommentaire_fg").focus();
      }
    };
    document.querySelector(".elCommentaire").addEventListener("click", mobileCheck);
    
    if (this.state.elCapture_visible && this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        elCapture_visible: false,
        elErase_visible: true,
      })
    } else if (!this.state.elCapture_visible && !this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        elCapture_visible: true,
        elErase_visible: false,
      })
    }
    
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
    
    if (this.state.elCapture_visible && this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        elCapture_visible: false,
        elErase_visible: true,
      })
    } else if (!this.state.elCapture_visible && !this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        elCapture_visible: true,
        elErase_visible: false,
      })
    }
    
  }

  textAreaChanged_elCommentaire = (event) => {
    this.setState({commentaire: event.target.value});
    
    this.props.appActions.updateDataSlot("ds_commentaire", event.target.value);
  }
  
  onClick_elImage = (ev) => {
    this.setState({elBig_image_visible: true});
  
  }
  
  
  onClick_elErase = (ev) => {
    let newVal = "";
    this.props.appActions.updateDataSlot('ds_saved_picture', newVal);
  
  }
  
  
  onClick_elCapture = (ev) => {
    // Go to screen 'Appareil photo'
    this.props.appActions.goToScreen('appareilPhoto', { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_elRetour = (ev) => {
    // Go to screen 'Tournée du jour'
    this.props.appActions.goToScreen('tournéeDuJour', { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_elValider = (ev) => {
    let a = window.confirm("Annuler cette commande?");
    
    if (!a) {
      return;
    }
    
    let update_ot = {
      document_ref: this.props.appActions.dataSlots['ds_selected_command'].document_ref,
      document_key: this.props.appActions.dataSlots['ds_selected_command'].document_key,
      statut: 2,
      photo: this.props.appActions.dataSlots['ds_saved_picture'],
      commentaire: this.state.commentaire || "",
      ts_charge: new Date().getTime(),
      coordinates_charge: {
        lat: window.previousPos.coords.latitude, 
        lng: window.previousPos.coords.longitude,
      },
      user_id_charge: this.props.appActions.dataSlots['ds_userid'],
      user_name_charge: this.props.appActions.dataSlots['ds_username'],
    }
    this.props.appActions.dataSheets['tournees_j'].replaceItemByRowIndex(update_ot.document_key, update_ot, this.props.appActions.serviceOptions_tournees_j);
    
    
    // UPDATE QUAI VIEW (POSE HORS QUAI)
    let dech_quai_view = this.props.appActions.dataSheets['quaiView'].items.filter(it => {
      return it.id_client === this.props.appActions.dataSlots['ds_client_id'];
    })[0];
    
    
    ///////////// CASE REPORTER //////////////
    // let entreprise = this.props.appActions.dataSheets['entreprise'].items[0]||{};
    
    let replanifier = true;
    if (replanifier) {
      let ot_row = this.props.appActions.dataSlots['ds_selected_command'];
      let date_ref = new Date(this.props.appActions.dataSlots['ds_selected_command'].date);
    
      let ts = new Date();
      ts =  ts.getTime();
    
      let keys_to_keep = [
        'abilities',
        'action',
        'adr',
        'client',
        'container_id',
        'coordinates',
        'default_action',
        'display_name',
        'duration',
        'exutoire',
        'flux',
        'heavy',
        'heure',
        'hh',
        'id_client',
        'id_scan',
        'ouverture',
        'packmat',
        'quai',
        'remark',
        'sector',
        'site',
        'sort_key',
        'state',
        'type',
        'zfe',      
      ];
      let modifications = {
        date: this.props.appActions.dataSlots['ds_today_minuit_ts'],
        driver: "",
        driver_id: "",
        etat: 'differe',
        photo: "",
        position: 0,
        report: ot_row.report,
        reference_diff: ot_row.document_key + " (" + date_ref.toLocaleDateString("FR-fr") + ")",
        statut : 0,
        tonnage: 0,
        tournee: "",
        truck: "",
        truck_id: "",
        ts: ts,
        user_id: this.props.appActions.dataSlots['ds_userid'],
        user_name: this.props.appActions.dataSlots['ds_username'],
      };
    
      let newOtPlanning = {...ot_row};
      Object.keys(newOtPlanning).forEach(k => {
        if (!keys_to_keep.includes(k)) {
          delete newOtPlanning[k];
        }
      })
      
      newOtPlanning = {...newOtPlanning, ...modifications};
      
      let tournees_collection = this.props.appActions.dataSheets['tournees_j'].firebase.firestore().collection("entreprises/"+this.props.appActions.dataSlots['ds_entreprise_id']+"/tournees/");
      tournees_collection.add(newOtPlanning).then(docRef => {
        console.log('Order success');
      })
        .catch(e => {
        console.log('ERROR : ', e);
      })
      //this.props.appActions.addToDataSheet('tournees_j', newOtPlanning);
    }
  
    // Go to screen 'Tournée du jour'
    this.props.appActions.goToScreen('tournéeDuJour', { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_elBig_image = (ev) => {
    this.setState({elBig_image_visible: false});
  
  }
  
  
  textAreaChanged_elCommentaire_fg = (event) => {
    this.setState({commentaire_fg: event.target.value});
    
    this.props.appActions.updateDataSlot("ds_commentaire", event.target.value);
  }
  
  onClick_elSave_input = (ev) => {
  
  
  
  }
  
  
  render() {
    let layoutFlowStyle = {};
    let baseStyle = {};
    if (this.props.transitionId && this.props.transitionId.length > 0 && this.props.atTopOfScreenStack && this.props.transitionForward) {
      baseStyle.animation = '0.25s ease-in-out '+this.props.transitionId;
    }
    if ( !this.props.atTopOfScreenStack) {
      layoutFlowStyle.height = '100vh';
      layoutFlowStyle.overflow = 'hidden';
    }
    
    const style_elBackground = {
      width: '100%',
      height: '100%',
     };
    const style_elBackground_outer = {
      backgroundColor: '#f6f6f6',
     };
    const style_elText = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'center',
     };
    
    const style_elRectangle = {
      background: 'rgba(213, 213, 213, 1.000)',
     };
    const style_elCard_ot_outer = {
      backgroundColor: 'white',
      filter: 'drop-shadow(0.0px 2.3px 18px rgba(0, 0, 0, 0.1600))',
      overflow: 'visible',
     };
    
    let transformValue_state_elImage_fill_full = (input) => {
      return input.state || 5;
    
    }
    
    let transformValue_type_elImage_fill_full = (input) => {
      let getContenantById = (id) => {
        return this.props.appActions.dataSheets['group_contenants'].items.find(it => it.document_key == id);
      }
      
      let getFluxByMatiere = (matiere) => {
        return this.props.appActions.dataSheets['matieres'].items.find(it => it.matiere == matiere);
      }
      
      let getMaterialByType = (type) => {
        return this.props.appActions.dataSheets['materiels'].items.find(it => it.type == type);
      }
      
      if (input.container_id == "null") {
        let type = (getMaterialByType(input.flux)||{}).code_shape||"30";
        return type;
      } else {
        let contenant = getContenantById(input.container_id) || {};
        let type = (getMaterialByType(contenant.type)||{}).code_shape||"30";
        return type;
      }
    }
    
    let transformValue_color_elImage_fill_full = (input) => {
      let getContenantById = (id) => {
        return this.props.appActions.dataSheets['group_contenants'].items.find(it => it.document_key == id);
      }
      
      let getFluxByMatiere = (matiere) => {
        return this.props.appActions.dataSheets['matieres'].items.find(it => it.matiere == matiere);
      }
      
      let getMaterialByType = (type) => {
        return this.props.appActions.dataSheets['materiels'].items.find(it => it.type == type);
      }
      
      return (getFluxByMatiere(input.flux)||{}).color || "#000000";
    }
    let transformPropValue_site = (input) => {
      return input.display_name;
    }
    
    const value_site = transformPropValue_site((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
    
    const style_elSite = {
      fontSize: 14.1,
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_flux = (input) => {
      return input.flux + (input.quai ? (" - quai " + input.quai) : " - Hors quai");
    }
    
    const value_flux = transformPropValue_flux((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
    
    const style_elFlux = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_type = (input) => {
      return input.type + (input.id_scan ? (" - " + input.id_scan) : "");
    }
    
    const value_type = transformPropValue_type((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
    
    const style_elType = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_exutoire = (input) => {
      if (input.action == 1 || input.action == 4) {
        return input.exutoire ? input.exutoire.label : '';
      } else {
        return '';
      }
    }
    
    const value_exutoire = transformPropValue_exutoire((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
    
    const style_elExutoire = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_remark = (input) => {
      if (input.action == 3 && input.hh != 'DI') {
        return "Prendre la benne à " + input.display_name;
      } else {
        return "" + (input.remark : '');
      }
    }
    
    const value_remark = transformPropValue_remark((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
    
    const style_elRemark = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    const style_elCard_outer = {
      backgroundColor: 'white',
      filter: 'drop-shadow(0.0px 2.3px 18px rgba(0, 0, 0, 0.1600))',
      overflow: 'visible',
     };
    
    const value_commentaire = (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_commentaire'] : '');
    
    const style_elCommentaire = {
      display: 'block',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      pointerEvents: 'auto',
     };
    const style_elImage = {
      backgroundImage: 'url('+((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_saved_picture'] : '') || img_elImage)+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'contain',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_elErase = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_685443925+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const elErase = this.state.elErase_visible ? (
      <div className="elErase">
        <button className="actionFont" style={style_elErase} onClick={this.onClick_elErase}  />
      </div>
      
     ) : null;
    
    const style_elCapture = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_505087+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '62.857%',
      paddingTop: '30%',
      backgroundPosition: '50% 0%',
      color: '#00e5d9',
      textAlign: 'center',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const elCapture = this.state.elCapture_visible ? (
      <div className="elCapture">
        <button className="actionFont" style={style_elCapture} onClick={this.onClick_elCapture} >
          Photo
        </button>
      </div>
      
     ) : null;
    
    const style_elRetour = {
      display: 'block',
      textTransform: 'none',
      color: '#fff',
      textAlign: 'center',
      backgroundColor: '#ff7d78',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_elValider = {
      display: 'block',
      textTransform: 'none',
      color: 'white',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elBig_image = {
      backgroundImage: 'url('+((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_saved_picture'] : '') || img_elBig_image)+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'contain',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const elBig_image = this.state.elBig_image_visible ? (
      <div className="elBig_image" style={style_elBig_image} onClick={this.onClick_elBig_image}  />
     ) : null;
    
    const value_commentaire_fg = this.state.commentaire_fg;
    
    const style_elCommentaire_fg = {
      display: 'block',
      backgroundColor: 'white',
      borderColor: 'lightGray',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
      display: 'none',
     };
    
    const style_elSave_input = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_255121260+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
      display: 'none',
     };
    
    return (
      <div className="AppScreen ChuterUnOTScreen" style={baseStyle}>
        <div className="background">
          <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
            <div className="appBg" style={style_elBackground} />
          </div>
        </div>
        
        <div className="layoutFlow" style={layoutFlowStyle}>
          <div className="elSpacer">
            <div />
          </div>
          
          <div className="elText">
            <div className="headlineFont" style={style_elText}>
              <div>{this.state.text}</div>
            </div>
          </div>
          
          <div className="elRectangle">
            <div style={style_elRectangle} />
          </div>
          
          <div className="flowRow flowRow_ChuterUnOTScreen_elCard_ot_276273553">
          <div className="elCard_ot" style={style_elCard_ot_outer}>
            <div className="cardBg" />
          </div>
          
          <div className="hasNestedComps elImage_fill_full">
            <div>
              <Image_fill state={transformValue_state_elImage_fill_full((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} type={transformValue_type_elImage_fill_full((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} color={transformValue_color_elImage_fill_full((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} ref={(el)=> this._elImage_fill_full = el} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />
            </div>
          </div>
          
          <div className="elSite">
            <div className="systemFontBold" style={style_elSite}>
              <div>{value_site !== undefined ? value_site : (<span className="propValueMissing">{this.state.site}</span>)}</div>
            </div>
          </div>
          
          <div className="elFlux">
            <div className="baseFont" style={style_elFlux}>
              <div>{value_flux !== undefined ? value_flux : (<span className="propValueMissing">{this.state.flux}</span>)}</div>
            </div>
          </div>
          
          <div className="elType">
            <div className="baseFont" style={style_elType}>
              <div>{value_type !== undefined ? value_type : (<span className="propValueMissing">{this.state.type}</span>)}</div>
            </div>
          </div>
          
          <div className="elExutoire">
            <div className="baseFont" style={style_elExutoire}>
              <div>{value_exutoire !== undefined ? value_exutoire : (<span className="propValueMissing">{this.state.exutoire}</span>)}</div>
            </div>
          </div>
          
          <div className="elRemark">
            <div className="baseFont" style={style_elRemark}>
              <div>{value_remark !== undefined ? value_remark : (<span className="propValueMissing">{this.state.remark}</span>)}</div>
            </div>
          </div>
          
          </div>
          <div className="elSpacer2">
            <div />
          </div>
          
          <div className="flowRow flowRow_ChuterUnOTScreen_elCard_2053344682">
          <div className="elCard" style={style_elCard_outer}>
            <div className="cardBg" />
          </div>
          
          <div className="elCommentaire">
            <Textarea className="baseFont" style={style_elCommentaire}  placeholder="Commentaire" onChange={this.textAreaChanged_elCommentaire} value={value_commentaire !== undefined ? value_commentaire : ''}  />
          </div>
          
          <div className="elImage">
            <div style={style_elImage} onClick={this.onClick_elImage}  />
          </div>
          
          { elErase }
          { elCapture }
          </div>
          <div className="elSpacerCopy">
            <div />
          </div>
          
          <div className="flowRow flowRow_ChuterUnOTScreen_elRetour_467334">
          <div className="elRetour">
            <Button className="actionFont" style={style_elRetour} onClick={this.onClick_elRetour} >
              Annuler
            </Button>
          </div>
          
          </div>
          <div className="elValider">
            <Button className="actionFont" style={style_elValider}  color="accent" onClick={this.onClick_elValider} >
              Confirmer
            </Button>
          </div>
        </div>
        <Appbar className="navBar">
          <div className="title">Annuler l'opération</div>  <div className="backBtn" onClick={ (ev)=>{ this.props.appActions.goBack() } }><img src={btn_icon_back_chuterunot} alt="" style={{width: '50%'}} /></div>
        </Appbar>
        
        <div className="screenFgContainer">
          <div className="foreground">
            { elBig_image }
            <textarea className="baseFont containerMinHeight elCommentaire_fg" style={style_elCommentaire_fg}  placeholder="Commentaire" onChange={this.textAreaChanged_elCommentaire_fg} value={value_commentaire_fg !== undefined ? value_commentaire_fg : ''}  />
            <button className="actionFont elSave_input" style={style_elSave_input} onClick={this.onClick_elSave_input}  />
          </div>
        </div>
      </div>
    )
  }
  
}
